<ng-container *ngIf="customerStory">
    I want to {{customerStory.want}} so that {{customerStory.reason}}
</ng-container>
